/*
 *
 * CollaboratorsSummary actions
 *
 */

import {
  GET_COLLABORATORS_SUMMARY_WATCHER,
  GET_COLLABORATORS_SUMMARY_SUCCESS,
  GET_COLLABORATORS_SUMMARY_FAILED,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
  UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
  SAVE_EXCEL_COLLABORATORS_WATCHER,
  SAVE_EXCEL_COLLABORATORS_SUCCESS,
  SAVE_EXCEL_COLLABORATORS_FAILED,
  SAVE_EXCEL_COLLABORATORS_PROGRESS,
  GET_CEASED_SUMMARY_WATCHER,
  GET_CEASED_SUMMARY_SUCCESS,
  GET_CEASED_SUMMARY_FAILED,
  UPLOAD_TEMPLATE_CEASED_WATCHER,
  UPLOAD_TEMPLATE_CEASED_SUCCESS,
  UPLOAD_TEMPLATE_CEASED_FAILED,
  SAVE_EXCEL_CEASED_SUCCESS,
  SAVE_EXCEL_CEASED_PROGRESS,
  SAVE_EXCEL_CEASED_FAILED,
  SAVE_EXCEL_CEASED_WATCHER,
  GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER,
  GET_DIVISIONS_ASSIGNMENT_SUMMARY_SUCCESS,
  GET_DIVISIONS_ASSIGNMENT_SUMMARY_FAILED,
  SAVE_EXCEL_DIVISIONS_ASSIGNMENT_WATCHER,
  SAVE_EXCEL_DIVISIONS_ASSIGNMENT_SUCCESS,
  SAVE_EXCEL_DIVISIONS_ASSIGNMENT_FAILED,
  SAVE_EXCEL_DIVISIONS_ASSIGNMENT_PROGRESS,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
  GET_TEAMS_SUMMARY_WATCHER,
  GET_TEAMS_SUMMARY_SUCCESS,
  GET_TEAMS_SUMMARY_FAILED,
  SAVE_EXCEL_TEAMS_WATCHER,
  SAVE_EXCEL_TEAMS_SUCCESS,
  SAVE_EXCEL_TEAMS_FAILED,
  SAVE_EXCEL_TEAMS_PROGRESS,
  UPLOAD_TEMPLATE_TEAMS_WATCHER,
  UPLOAD_TEMPLATE_TEAMS_SUCCESS,
  UPLOAD_TEMPLATE_TEAMS_FAILED,
} from "./constants"


// SAVE EXCEL TEAMS
export function saveTeamsWatcher(payload) {
  return {
    type: SAVE_EXCEL_TEAMS_WATCHER,
    payload,
  }
}

export function saveTeamsSuccess(payload) {
  return {
    type: SAVE_EXCEL_TEAMS_SUCCESS,
    payload,
  }
}

export function saveTeamsFailed() {
  return { 
    type: SAVE_EXCEL_TEAMS_FAILED 
  }
}

export function saveTeamsProgress(payload) {
  return {
    type: SAVE_EXCEL_TEAMS_PROGRESS,
    payload,
  }
}

// SAVE EXCEL CEASED
export function saveCollaboratorsCeasedWatcher(payload) {
  return {
    type: SAVE_EXCEL_CEASED_WATCHER,
    payload,
  }
}

export function saveCollaboratorsCeasedSuccess(payload) {
  return {
    type: SAVE_EXCEL_CEASED_SUCCESS,
    payload,
  }
}

export function saveCollaboratorsCeasedFailed() {
  return { type: SAVE_EXCEL_CEASED_FAILED }
}

export function saveCollaboratorsCeasedProgress(payload) {
  return {
    type: SAVE_EXCEL_CEASED_PROGRESS,
    payload,
  }
}

// UPLOAD EXCEL CEASEd
export function uploadTemplateCeasedWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_CEASED_WATCHER,
    payload,
  }
}

export function uploadTemplateCeasedSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_CEASED_SUCCESS,
    payload,
  }
}

export function uploadTemplateCeasedFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_CEASED_FAILED,
    payload,
  }
}

// GET SUMMARY COLLABORATORS
export function getCeasedSummaryWatcher() {
  return { type: GET_CEASED_SUMMARY_WATCHER }
}

export function getCeasedSummarySuccess(payload) {
  return {
    type: GET_CEASED_SUMMARY_SUCCESS,
    payload,
  }
}

export function getCeasedSummaryFailed() {
  return { type: GET_CEASED_SUMMARY_FAILED }
}

// SAVE EXCEL COLLABORATORS
export function saveExcelCollaboratorsWatcher(payload) {
  return {
    type: SAVE_EXCEL_COLLABORATORS_WATCHER,
    payload,
  }
}

export function saveExcelCollaboratorsSuccess(payload) {
  return {
    type: SAVE_EXCEL_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function saveExcelCollaboratorsFailed() {
  return { type: SAVE_EXCEL_COLLABORATORS_FAILED }
}

export function saveExcelCollaboratorsProgress(payload) {
  return {
    type: SAVE_EXCEL_COLLABORATORS_PROGRESS,
    payload,
  }
}

export function saveExcelDivisionsAssignmentWatcher(payload) {
  return {
    type: SAVE_EXCEL_DIVISIONS_ASSIGNMENT_WATCHER,
    payload,
  }
}

export function saveExcelDivisionsAssignmentSuccess(payload) {
  return {
    type: SAVE_EXCEL_DIVISIONS_ASSIGNMENT_SUCCESS,
    payload,
  }
}

export function saveExcelDivisionsAssignmentFailed(payload){ 
  return {
    type: SAVE_EXCEL_DIVISIONS_ASSIGNMENT_FAILED,
    payload,
  }
}

export function saveExcelDivisionsAssignmentProgress(payload) {
  return {
    type: SAVE_EXCEL_DIVISIONS_ASSIGNMENT_PROGRESS,
    payload,
  }
}



// GET SUMMARY COLLABORATORS
export function getCollaboratorsSummaryWatcher() {
  return { type: GET_COLLABORATORS_SUMMARY_WATCHER }
}

export function getCollaboratorsSummarySuccess(payload) {
  return {
    type: GET_COLLABORATORS_SUMMARY_SUCCESS,
    payload,
  }
}

export function getTeamsSummaryFailed() {
  return { type: GET_TEAMS_SUMMARY_FAILED }
}


export function getTeamsSummaryWatcher() {
  return { type: GET_TEAMS_SUMMARY_WATCHER }
}

export function getTeamsSummarySuccess(payload) {
  return {
    type: GET_TEAMS_SUMMARY_SUCCESS,
    payload,
  }
}

export function getCollaboratorsSummaryFailed() {
  return { type: GET_COLLABORATORS_SUMMARY_FAILED }
}

export function getDivisionsAssignmentSummaryWatcher() {
  return { type: GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER }
}

export function getDivisionsAssignmentSummarySuccess(payload) {
  return {
    type: GET_DIVISIONS_ASSIGNMENT_SUMMARY_SUCCESS,
    payload,
  }
}

export function getDivisionsAssignmentSummaryFailed(payload) {
  return {
    type: GET_DIVISIONS_ASSIGNMENT_SUMMARY_FAILED,
    payload,
  }
}

// UPLOAD EXCEL
export function uploadTemplateCollaboratorsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
    payload,
  }
}

export function uploadTemplateCollaboratorsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function uploadTemplateCollaboratorsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
    payload,
  }
}


export function uploadTemplateDivisionsAssignmentWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
    payload
  }
}
// UPLOAD EXCEL TEAMS
export function uploadTemplateTeamsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_TEAMS_WATCHER,
    payload,
  }
}

export function uploadTemplateDivisionsAssignmentSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS,
    payload
  }
}

export function uploadTemplateTeamsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_TEAMS_SUCCESS,
    payload,
  }
}

export function uploadTemplateDivisionsAssignmentFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED,
    payload,
  }
}
export function uploadTemplateTeamsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_TEAMS_FAILED,
    payload,
  }
}
